import { render, staticRenderFns } from "./ScrollCard.vue?vue&type=template&id=787d6bde&scoped=true"
import script from "./ScrollCard.vue?vue&type=script&lang=js"
export * from "./ScrollCard.vue?vue&type=script&lang=js"
import style0 from "./ScrollCard.vue?vue&type=style&index=0&id=787d6bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d6bde",
  null
  
)

export default component.exports